export default class AHBoolean {
  private readonly _value: boolean;

  constructor(value: boolean) {
    this._value = value;
  }
  
  isEqualTo(other: AHBoolean): boolean {
    return this.value === other?.value;
  }

  public get isEmpty(): boolean {
    return !this.value;
  }

  public get value(): boolean {
    return this._value;
  }

  public static get Prototype(): AHBoolean {
    return new AHBoolean(false);
  }

  public fromJSON(value: boolean): AHBoolean {
    return new AHBoolean(value);
  }
  public static fromJSON(value: boolean): AHBoolean {
    return new AHBoolean(value);
  }

  public toJSON(): boolean {
    return this.value;
  }
  public clone(): AHBoolean {
    return new AHBoolean(this.value);
  }
}
